import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { finalize, switchMap } from 'rxjs/operators'
import { ApiService } from 'src/app/services/api.service'
import { AccountDto } from 'src/app/services/dtos'
import { UiService } from 'src/app/services/ui.service'
import { handleArpioError } from 'src/utils/handle-error'
import { subscriptionActive } from 'src/utils/rxjs-utils'

@Component({
  selector: 'app-select-linked-account',
  templateUrl: './select-linked-account.component.html',
  styleUrls: ['./select-linked-account.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SelectLinkedAccountComponent implements OnInit, OnDestroy {
  private loadAccountSubscription: Subscription = null
  accounts: Array<AccountDto> = null
  private token: string = null

  constructor(
    private activatedRoute: ActivatedRoute,
    public uiService: UiService,
    private apiService: ApiService,
    private router: Router
  ) {}

  ngOnInit() {
    this.token = this.activatedRoute.snapshot.queryParamMap.get('awsToken')
    if (!this.token) {
      this.router.navigateByUrl(this.uiService.awsMarketplaceErrorUrl)
    } else {
      this.loadAccountSubscription = this.apiService
        .listAccounts()
        .pipe(finalize(() => (this.loadAccountSubscription = null)))
        .subscribe(
          (accounts) => (this.accounts = accounts),
          handleArpioError(window.location.href, this.apiService, this.uiService)
        )
    }
  }

  ngOnDestroy() {
    if (subscriptionActive(this.loadAccountSubscription)) {
      this.loadAccountSubscription.unsubscribe()
    }
  }

  reLogin() {
    this.loadAccountSubscription = this.apiService
      .logout()
      .pipe(
        switchMap((_null) => this.apiService.listAccounts()),
        finalize(() => (this.loadAccountSubscription = null))
      )
      .subscribe(
        (accounts) => (this.accounts = accounts),
        handleArpioError(window.location.href, this.apiService, this.uiService)
      )
  }

  linkAccount(account: AccountDto) {
    this.apiService
      .submitEntitlementToken(account.accountId, this.token)
      .subscribe(
        (_null) => this.router.navigateByUrl(this.uiService.buildAccountRootUrl(account.accountId)),
        handleArpioError(window.location.href, this.apiService, this.uiService)
      )
  }

  newAccountClick() {
    this.router.navigateByUrl(this.uiService.buildCreateAccountUrl(), { state: { entitlementToken: this.token } })
  }
}
